import { render, staticRenderFns } from "./ReviewAndConfirm.vue?vue&type=template&id=66326bb2&scoped=true"
import script from "./ReviewAndConfirm.vue?vue&type=script&lang=js"
export * from "./ReviewAndConfirm.vue?vue&type=script&lang=js"
import style0 from "./ReviewAndConfirm.vue?vue&type=style&index=0&id=66326bb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66326bb2",
  null
  
)

export default component.exports